import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useRef, useState } from 'react';
import { Swiper as SwiperType } from 'swiper/types';
import './index.scss';
import 'swiper/scss';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

export default function Content({ callback }: { callback: (i: string) => void }) {
    const swiperRef = useRef<any>(null);
    const isClick = useRef<boolean>(false);
    const isClickTimer = useRef<NodeJS.Timeout | null>(null);
    const { t } = useLang('business');
    const prefixCls = 'product-category';
    const [active, setActive] = useState<string>(t('tab_title_4'));
    const [isFixed, setIsFixed] = useState<boolean>(false);
    const [isShowBar, setIsShowBar] = useState<boolean>(false);
    const [top, setTop] = useState<number>(0);
    const [css, setCss] = useState({ left: 0, width: 80, opacity: 0 });
    const items = [
        {
            name: t('tab_title_4'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1766137711575/1-4.png',
            anchor: t('tab_title_4'),
        },
        {
            name: t('tab_title_2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1766137711967/1-2.png',
            anchor: t('tab_title_2'),
        },

        {
            name: t('tab_title_1'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1766137711164/1-1.png',
            anchor: t('tab_title_1'),
        },
        {
            name: t('tab_title_3'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1766137711774/1-3.png',
            anchor: t('tab_title_3'),
        },

        {
            name: t('tab_title_5'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1766137711345/1-5.png',
            anchor: t('tab_title_5'),
        },
    ];

    const getHeaderH = () => {
        let h = 0;
        const header: HTMLHeadingElement | null = document.querySelector('.ecoflow-frame-header') || document.querySelector(`.global-header`);
        if (header) {
            const styles = window.getComputedStyle(header);
            const position = styles.position;
            h += Number(position === 'sticky' ? header?.offsetHeight : 0) || 0;
        }
        return h;
    };

    const initTopPosition = () => setTop(getHeaderH());

    const listenScroll = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > top + 10) {
            setIsFixed(true);
        } else if (scrollTop < top) {
            setIsFixed(false);
        }
        // setTimeout(() => {
        //     listenScrollCss(active);
        // }, 250);
    };

    const listenScrollCss = (anchor: string) => {
        // swiper 动画
        if (swiperRef.current) {
            const swiper = swiperRef.current;
            const index = items.findIndex((i) => anchor === i.anchor);
            // @ts-ignore
            const wrapperWidth = swiper.virtualSize; // Swiper 内部计算的总宽度
            const slide = swiper.slides[index] as HTMLDivElement;
            const slideWidth = slide.offsetWidth;
            const slideLeft = slide.offsetLeft;
            const swiperWidth = swiper.width;
            // 原始目标位置：让 slide 居中
            let target = slideLeft - swiperWidth / 2 + slideWidth / 2;
            // 👉 做边界处理
            const minTranslate = 0; // 不允许向右移动超过起点
            const maxTranslate = wrapperWidth - swiperWidth; // 不允许向左移动超过终点
            // 夹紧偏移量（防止空白）
            target = Math.min(Math.max(target, minTranslate), maxTranslate);
            swiper.slideTo(index, 300);
            swiper.translateTo(-target, 300);
        }

        // // 选中条动画
        // const targetItem: HTMLAnchorElement | null = document.querySelector(
        //     `.editor-${prefixCls} .product-category-swiper-slide-item[href="${anchor?.startsWith('#') ? `#editor-${anchor.slice(1)}}` : `#editor-${anchor}`
        //     }"]`,
        // );
        // 选中条动画
        const targetItem: HTMLAnchorElement | null = document.querySelector(`.editor-${prefixCls} .active .product-category-swiper-slide-item`);
        const wrapper = document.querySelector(`.editor-${prefixCls} .swiper-wrapper`);

        if (targetItem && wrapper) {
            const recc = wrapper.getBoundingClientRect();
            const rect = targetItem.getBoundingClientRect();
            setCss({
                opacity: 1,
                width: rect.width,
                left: rect.left - recc.left,
            });
        }
    };

    // 处理锚点点击事件 部分dom被遮挡的问题
    const handleClick = (item: any) => {
        // 点击情况下，阻止滚动判断执行
        // if (isClickTimer.current !== null) {
        //     clearTimeout(isClickTimer.current);
        //     isClickTimer.current = null;
        // }
        // isClick.current = true;
        // isClickTimer.current = setTimeout(() => {
        //     isClick.current = false;
        // }, 1000);

        // if (item.type === 'link') return;
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'business',
            button_name: item.name,
            __btn_id1: `business-B .tab-${item.anchor}`,
            __btn_id2: item.name,
            __btn_type: 'text',
        });
        setActive(item.anchor);
        callback(item.anchor);
        setTimeout(() => {
            listenScrollCss(item.anchor);
        }, 10);
        window.sessionStorage.removeItem('toTop-scrollTop');
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            initTopPosition();
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', listenScroll);
            return () => {
                window.removeEventListener('scroll', listenScroll);
            };
        }
    }, [top]);

    useEffect(() => {
        listenScrollCss(active);
        setTimeout(() => {
            setIsShowBar(true);
        }, 200);
    }, []);

    return (
        <>
            <div className={`editor-${prefixCls} business-B  sticky-${isFixed ? 'yes' : 'no'}`} style={{ top: `${top}px` }}>
                <Swiper
                    className={`${prefixCls}-swiper ${isShowBar ? 'show-bar' : ''}`}
                    initialSlide={0}
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    // @ts-ignore
                    style={{ '--left': `${css.left}px`, '--width': `${css.width}px`, '--opacity': css.opacity }}
                >
                    {items?.map((item, k: number) => (
                        <SwiperSlide className={`${prefixCls}-swiper-slide  ${item.anchor === active ? ` active` : ''}`} data-anchor={item.anchor} key={k}>
                            <div
                                className={`${prefixCls}-swiper-slide-item tab-${item.anchor}`}
                                style={{ scrollMarginTop: `80px` }}
                                onClick={() => handleClick(item)}
                            >
                                <div className={`${prefixCls}-swiper-slide-item-img`}>
                                    <EcoImg pc={item.img} alt={item.name} aria-label={item.name} />
                                </div>
                                <p className={`${prefixCls}-swiper-slide-item-name`} title={item?.name}>
                                    {item.name}
                                </p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    );
}
